import script from "./PlacesListFromCodes.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlacesListFromCodes.vue?vue&type=script&lang=ts&setup=true"

import "./PlacesListFromCodes.vue?vue&type=style&index=0&id=65b3949e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b3949e"]])

export default __exports__